import React from 'react'

/**
 *
 * @param {object} props
 * @param {string} props.content
 * @param {string} props.linkText
 * @param {string} props.linkUrl
 */
export default function SurveyPublishDescription({ content, linkText, linkUrl }) {
  return (
    <React.Fragment>
      {content.split('\n').map((contentLine, index) => {
        return <p key={index}>{contentLine}</p>
      })}
      <p>
        <a href={linkUrl} target="_blank" rel="noopener">
          <i className="icon far fa-book" />
          {linkText}
        </a>
      </p>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyPublishDescription/index.js